import { useEffect, useRef } from 'react';
import { trpc } from '@/lib/trpc';

/**
 * Hook to keep user session alive during inactivity
 * Automatically refreshes auth every 4 minutes to prevent session expiration
 */
export function useSessionKeepAlive(enabled = true) {
  const utils = trpc.useUtils();
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!enabled) return;

    // Refresh session every 4 minutes (240 seconds)
    // This keeps the session alive without user interaction
    intervalRef.current = setInterval(() => {
      utils.auth.me.refetch().catch(() => {
        // Silently ignore errors - queries will auto-retry
      });
    }, 4 * 60 * 1000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [enabled, utils]);
}
